<div class="container">
  <div class="title">MY JOBS</div>
  <div class="item" *ngFor="let jobQueueItem of jobQueueItems; trackBy: trackByIndex">
    <div *ngIf="isNewStartDate(jobQueueItem)" class="startdatetime">{{formatHoldStartDateTime()}}</div>
    <app-jobqueue-item [jobQueueItem]="jobQueueItem"></app-jobqueue-item>
  </div>
</div>


